import React from 'react';
import { ReactComponent as IconClose } from 'static/ic-close.svg';
import { selectIsModalOpened } from 'state/selectors';
import { ModalBody, ModalClose, ModalContainer, ModalFooter, ModalHeader, ModalHeaderContent } from '../Modal/view';
import { CustomModalWrapper, Overlay } from './CustomModalLayout.view';

type ModalProps = {
    header?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    onClose: () => void;
    isCompactLayout?: boolean;
};

export const CustomModalLayout = ({ header, children, footer, onClose, isCompactLayout }: ModalProps) => {
    const isOpen = selectIsModalOpened();

    return (
        <Overlay>
            <CustomModalWrapper $isCompactLayout={isCompactLayout} opened={isOpen}>
                <ModalContainer>
                    <ModalHeader>
                        <ModalHeaderContent>{header}</ModalHeaderContent>
                        <ModalClose onClick={onClose}>
                            <IconClose />
                        </ModalClose>
                    </ModalHeader>
                    <ModalBody>{children}</ModalBody>
                    <ModalFooter>{footer}</ModalFooter>
                </ModalContainer>
            </CustomModalWrapper>
        </Overlay>
    );
};
